import { Prestadores } from 'app/models/prestadores.model';
import * as fromActions from '../actions';
import { PrestadoresState } from '../models/store.models';

const initialState: PrestadoresState = {
    prestadorList: {
        contenido: [],
        paginado: {
            elementosTotales: 0,
            paginaActual: 0,
            paginasTotales: 0,
        },
    },
    search: {
        searchTerm: [''],
        searchCriteria: ['cuit'],
    },
};

export function prestadoresReducer(
    state: PrestadoresState = initialState,
    action: fromActions.PrestadoresActions
): PrestadoresState {
    switch (action.type) {
        case fromActions.SET_PRESCRIPTORS:
            console.log(state);
            return {
                prestadorList: {
                    contenido: action.prestadoresSeteado.contenido,
                    paginado: {
                        elementosTotales:
                            action.prestadoresSeteado.paginado.elementosTotales,
                        paginaActual:
                            action.prestadoresSeteado.paginado.paginaActual,
                        paginasTotales:
                            action.prestadoresSeteado.paginado.paginasTotales,
                    },
                },
                search: state.search,
            };

        case fromActions.SET_PRESCRIPTORS_SEARCH_TERM:
            return {
                prestadorList: state.prestadorList,
                search: {
                    searchTerm: [...action.search.searchTerm],
                    searchCriteria: [...action.search.searchCriteria],
                },
            };
        // case fromActions.UNSET_PRESCRIPTORS:
        //     return {
        //         // prestadorList: [],
        //     };
        // case fromActions.SET_SINGLE_PRESCRIPTOR:
        //     const updatedPrestadores = state.prestadorList.contenido.map(
        //         (prestador) =>
        //             prestador.id === action.singlePrescriptorSeteado.id
        //                 ? { ...prestador, ...action.singlePrescriptorSeteado }
        //                 : prestador
        //     );

        //     return {
        //         ...state,
        //         prestadorList: updatedPrestadores,
        //     };
        default:
            return state;
    }
}
